export const USER_GRADE_SUMMARY_MODELS = {
  userGrade: {
    id: null,
    grade: null,
    name: null,
    imgUrl: null,
    purchaseAmount: null,
    purchaseCount: null,
    periodMonth: null,
  },
  recentPurchase: {
    startDate: null,
    endDate: null,
    purchaseAmount: null,
    numberOfPurchase: null,
  },
};

export const USER_GRADE_HISTORY_MODEL = {
  totalCount: 0,
  userGradeHistories: [],
};
